module.exports = __webpack_public_path__ + "static/media/shipment-truck-icon.e7ee37b6.svg";